import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const termsAndConditionsAtom = atomWithStorage(
  "termsAccepted",
  JSON.parse(localStorage.getItem("termsAccepted")) ?? false
);

const useTermsAndConditionsAtom = () => {
  const atom = useAtom(termsAndConditionsAtom);
  return atom;
};

export const useSetTermsAndConditions = () =>
  useSetAtom(termsAndConditionsAtom);

export default useTermsAndConditionsAtom;
